import React from "react";

// IMAGE IMPORTS
import blog08 from "../../../images/blog/img08.jpg";
import blog09 from "../../../images/blog/img09.jpg";
import blog10 from "../../../images/blog/img10.jpg";
import blog11 from "../../../images/blog/img11.jpg";

// import RelatedBlog from "./RelatedBlog";
import { Link } from "react-router-dom";

import CommentForm from "../CommentForm";
import RelatedBlog from "../RelatedBlog";
import ItemDetailsContent from "./ItemDetailsContent";



const DataSolutions: React.FC = () => {
  return (
    <section className="blog_details_section pt-70">
      <div className="container">

        {/* MAIN IMAGE */}
        <div className="single-item-image mb-70">
          <img src={blog08} alt="Blog" />
        </div>

        {/* HEADER META */}
        <ItemDetailsContent />

        {/* CONTENT ROW */}
        <div className="row mt-none-30 g-0 align-items-center">
          <div className="col-lg-12  container">

            <div className="blog_details_content">

              {/* AUDIO BUTTON */}
              {/* <div className="post_audio">
                <button className="audio_play_btn xb-border" type="button">
                  <i className="fas fa-play"></i>
                  <span className="time">6:24</span>
                  <span>Listen to this article!</span>
                </button>
              </div> */}

              {/* MAIN HEADING */}
              <h3 className="item_details_info_heading mb-35">
                AI insights that turn complex data into clear, confident business actions.
              </h3>

              {/* <div className="row mb-35 mt-none-30">
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog09} alt="Blog" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog10} alt="Blog" />
                  </div>
                </div>
              </div> */}

              <p>
                At our AI SaaS and data solutions company, we help businesses unlock the full potential of their data through advanced analytics, machine learning, and intelligent automation. Our solutions are designed to simplify complexity, deliver real-time intelligence, and enable faster, more accurate decision-making across all business functions.
              </p>

              <p className="mt-20">
               We work closely with organizations to understand their data challenges and business goals. By developing tailored AI systems, we ensure that insights are not only accurate but actionable. Whether it’s improving operational efficiency, enhancing customer experiences, or driving revenue growth, our AI-driven approach delivers measurable impact while supporting long-term scalability.
              </p>

              {/* VIDEO EMBED */}
              {/* <div className="blog-details-video mt-75">
                <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/reUZRyXxUs4?si=6Yv0cbndvuHukaXB" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
              </div> */}
               <div className="row mb-45 align-items-center mt-60">
                <div className="col-md-6 mt-30">
    <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/reUZRyXxUs4?si=6Yv0cbndvuHukaXB" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">Advanced Data Analytics.</span></li>
                    <li><span className="iconlist_text">Real-Time Intelligence.</span></li>
                    <li><span className="iconlist_text">Predictive & Prescriptive Analytics.</span></li>
                    <li><span className="iconlist_text">Machine Learning Models.</span></li>
                    <li><span className="iconlist_text">Instant Trigger AutomationScalable AI Infrastructure.</span></li>
                    <li><span className="iconlist_text">Seamless System Integration.</span></li>
                  </ul>
                </div>
              </div>
              <h3 className="item_details_info_heading mb-20 mt-60">
               Turning Complex Data into Actionable Intelligence
              </h3>

              <p className="mb-40">
               AI powered data solutions go beyond traditional analytics by continuously learning from data, identifying patterns, and predicting future outcomes. Instead of relying on static reports, businesses gain dynamic, real-time insights that evolve with changing conditions.<br></br>
                By combining data engineering, machine learning, and intelligent dashboards, our solutions enable organizations to move from reactive decision-making to proactive, insight-driven strategies.
              </p>
              

              {/* IMAGE + LIST */}
             

              <h3 className="item_details_info_heading mb-25">3 Ways AI-Powered Data Solutions Transform Businesses</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. Smarter Decision-Making.</span></li>
                <li><span className="iconlist_text">2. Improved Operational Efficiency..</span></li>
                <li><span className="iconlist_text">3. Sustainable Growth & Competitive Advantage.</span></li>
              </ul>

              {/* AUTHOR BLOCK */}
              {/* <div className="post-block-wrap mb-50">
                <div className="postabmin_block xb-border ul_li">

                  <div className="admin_image">
                    <img src={avatar1} alt="Author" />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">Aiden Brooks</h4>
                    <span className="admin_designation">Content Manager</span>
                    <p>A content editor plays a pivotal role in shaping and refining digital content...</p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li><Link to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>

                </div>
              </div> */}

              {/* TAGS + SOCIAL */}
              <div className="row mt-none-30">
                {/* <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li><Link className="xb-border" to="/blog-details">AI Solutions</Link></li>
                    <li><Link className="xb-border" to="/blog-details">Data Science</Link></li>
                    <li><Link className="xb-border" to="/blog-details">SaaS</Link></li>
                  </ul>
                </div> */}

                {/* <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-twitter"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fas fa-share-alt"></i></Link></li>
                  </ul>
                </div> */}
              </div>

              {/* COMMENTS AREA */}
              {/* <CommentsArea /> */}

              {/* COMMENT FORM */}
              <CommentForm />

              {/* SUBSCRIBE BOX */}
              {/* <NewsletterBox /> */}
            </div>
          </div>
          {/* <BlogSidebar /> */}
        </div>

        <RelatedBlog/>

      </div>
    </section>
  );
};

export default DataSolutions;
